import { render, staticRenderFns } from "./UserDropDownMenu.vue?vue&type=template&id=6e6f1249&scoped=true"
import script from "./UserDropDownMenu.vue?vue&type=script&lang=js"
export * from "./UserDropDownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6f1249",
  null
  
)

export default component.exports